
























































































































































































































import IInboundDeliveryNotesDetail from '@/store/models/IInboundDeliveryNotesDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IInbound from '@/store/models/IInbound';
import InboundDetailDeliveryNotesDetailSelector from '@/components/selectors/Inbounds/InboundDetailDeliveryNotesDetailSelector.vue';
import IInboundDeliveryNotes from '@/store/models/IInboundDeliveryNotes';
import IInboundDetail from '@/store/models/IInboundDetail';
import IListPalletType from '@/store/models/IListPalletType';
import IGood from '@/store/models/IGood';
import moment from 'moment';
import Snackbar from '@/components/shared/Snackbar.vue';
import JSPDF from 'jspdf';
import HTML2CANVAS from 'html2canvas';
import IWarehouse from '@/store/models/IWarehouse';
import IStock from '@/store/models/IStock';
import QRCode from "qrcode";
import WarehouseApi from '../../../store/api/WarehouseApi';
@Component({
    components: {
        InboundDetailDeliveryNotesDetailSelector,
        Snackbar
    }
})
export default class InboundDeliveryNotesDetailSelector extends Vue {
    searchInboundDeliveryNotesDetail: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Good',
            align: 'start',
            value: 'goodName'
        },
        { text: 'Pallet type', value: 'palletName' },
        { text: 'Pallet amount', value: 'palletsAmount' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Good per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Cases loss', value: 'casesLoss' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Weight per pallet (Kg)', value: 'weight' },
        { text: 'Language', value: 'language' },
        { text: 'Actions', value: 'actions' }
    ];
    editedIndex : number = -1;
    editedItem : IInboundDeliveryNotesDetail = {
        id: "",
        idInboundDeliveryNote: "",
        idInboundDetail: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        palletsAmount: 0,
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        location: "",
        weight: 0,
        bestBeforeDate: new Date(),
        idPallet: "",
        casesLoss: 0,
        language: ""
    }
    defaultItem : IInboundDeliveryNotesDetail = {
        id: "",
        idInboundDeliveryNote: "",
        idInboundDetail: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        palletsAmount: 0,
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        location: "",
        weight: 0,
        bestBeforeDate: new Date(),
        idPallet: "",
        casesLoss: 0,
        language: ""
    }

    @Prop({ type: Array, required: true })
    InboundDeliveryNotesDetailList !: IInboundDeliveryNotesDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop()
    idInboundDeliveryNote !: IInboundDeliveryNotes;
    @Prop({ type: Array, required: true })
    InboundDetailDeliveryNotesDetailList !: IInboundDetail[];
    @Prop({ type: Array, required: true })
    PalletTypesList !: IListPalletType;
    @Prop({ type: Array, required: true })
    GoodList !: IGood[];
    @Prop()
    SelectedInbound !: IInbound;
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedInbounds !: boolean;
    @Prop({ type: Boolean, default: false })
    CanModifyCompletedInboundsDeliveryNotes !: boolean;
    @Prop({ type: Boolean, default: false })
    ScannerActive !: boolean;
    @Prop()
    SelectedWarehouse !: IWarehouse;
    @Prop({ type: Array, default: () => [] })
    StockAvailableForInbound !: IStock[];

    selectedInboundDeliveryNotesDetail : IInboundDeliveryNotesDetail[] = [];
    selectedInboundDetailDeliveryNotesDetail : IInboundDetail[] | null = null;
    dialogPrintLabels: boolean = false;
    selectedForLabels: IInboundDeliveryNotesDetail[] = [];
    currentItem: IStock = {} as IStock;
    showTemplate: boolean = false;
    overlay: boolean = false;
    contentToPrint: HTMLElement | null = null;
    qrCodeData: string = "";
    isLoadingStockForLabels: boolean = false;

    mounted() {
        this.contentToPrint = this.$refs.contentToPrint as HTMLElement;
    }

    get formTitle() { return this.editedIndex === -1 ? 'New Delivery NotesDetail' : 'Edit Delivery NotesDetail'; }
    get printLabelsHeaders() {
        return [
            { text: 'Good', value: 'goodName' },
            { text: 'Total pallets', value: 'palletsAmount' }
        ];
    }
    
    async emitGetStockDetails() {
        this.isLoadingStockForLabels = true;
        this.overlay = true;

        // OJO: no se puede await $emit
        this.$emit("getStockByInboundAndWarehouse", this.SelectedInbound.id, this.SelectedWarehouse.id);

    // NO llames aquí a printLabels()
    }

    async updateQrValue() {
        const data = JSON.stringify({
            version: "3",
            id: this.currentItem!.id,
            idPallet: this.currentItem!.idPallet || '',
            idInbound: this.SelectedInbound!.id || '',
            idInboundDeliveryNoteDetail: this.currentItem!.idInboundDeliveryNoteDetail || '',
            type: "pallet"
        });
        this.qrCodeData = await QRCode.toDataURL(data, { width: 120, margin: 1 });
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    HasRightModifyCompletedInbounds() {
        if (!this.Permissions[0].isWritable || (this.SelectedInbound.statusName === 'Completed' && !this.CanModifyCompletedInbounds)) return false;
        if (this.CanModifyCompletedInboundsDeliveryNotes === false) return false;
        return true;
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    HasPermissionToSave() : boolean {
        if (Object.keys(this.SelectedInbound).length !== 0) {
            if (this.Permissions[0].isWritable) {
                return true;
            }
        }
        return false;
    }

    resetInboundDeliveryNotesDetail() {
        this.selectedInboundDeliveryNotesDetail = [];
        this.$emit('resetInboundDeliveryNotesDetail');
    }
    @Watch("StockAvailableForInbound")
    onStockLoaded(newVal: IStock[]) {
        if (!this.isLoadingStockForLabels) return;
        if (!newVal || newVal.length === 0) return;

        this.isLoadingStockForLabels = false;
        this.printLabels();
    }

    onUpdateInboundDetailDeliveryNotesDetail(updatedItem: IInboundDetail) {
        const index = this.InboundDetailDeliveryNotesDetailList.findIndex(i => i.id === updatedItem.id);
        if (index !== -1) {
            Object.assign(this.InboundDetailDeliveryNotesDetailList[index], updatedItem);
        }
    }
    saveInboundDeliveryNotesDetail() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (!this.selectedInboundDetailDeliveryNotesDetail) {
                this.showMessageWarning('Please select a delivery note detail to save');
                return;
            }

            // ⚠️ Validación: comprobar si el pallet amount es 0
            const detail = this.selectedInboundDetailDeliveryNotesDetail;
            // Si puede ser array, tomamos el primero
            const item = Array.isArray(detail) ? detail[0] : detail;

            if (!item || Number(item.palletsAmount) <= 0) {
                this.showMessageWarning('Pallet amount must be greater than 0 to save.');
                return;
            }

            // ✅ Si pasa la validación, guardamos
            if (this.SelectedInbound.statusName !== 'Completed' || this.CanModifyCompletedInbounds) {
                this.$emit('saveInboundDeliveryNotesDetail', this.selectedInboundDetailDeliveryNotesDetail);
            }

            this.close();
        } else {
            this.showMessageWarning('All required fields must be filled out');
        }
    }

    deleteInboundDeliveryNotesDetail (inboundDeliveryNotesDetail: IInboundDeliveryNotesDetail) {
        if (this.selectedInboundDeliveryNotesDetail.length > 0) {
            this.$emit('deleteInboundDeliveryNotesDetail', inboundDeliveryNotesDetail);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectInboundDeliveryNotesDetail(item : any) : void {
        if (!this.selectedInboundDeliveryNotesDetail.includes(item)) {
            this.selectedInboundDeliveryNotesDetail = [];
            this.selectedInboundDeliveryNotesDetail = [item];
        } else {
            this.selectedInboundDeliveryNotesDetail = [];
        }
    }

    getInboundDetailDeliveryNotes() {
        this.selectedInboundDetailDeliveryNotesDetail = [];
        this.$emit('getInboundDetailDeliveryNotes');
    }

    select(item : IInboundDeliveryNotesDetail) : void {
        let index : number = this.selectedInboundDeliveryNotesDetail.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedInboundDeliveryNotesDetail = [item];
        } else {
            let inboundDeliveryNotesDetail = this.selectedInboundDeliveryNotesDetail.find(w => w.id === item.id);
            if (!inboundDeliveryNotesDetail) {
                this.selectedInboundDeliveryNotesDetail = [];
            }
        }
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }

    async printLabels() {
        if (this.selectedForLabels.length === 0) {
            this.overlay = false;
            this.showMessageWarning("Please select at least one line");
            return;
        }

        // Si aún está cargando stock, no hagas nada (evita warnings falsos)
        if (this.isLoadingStockForLabels) return;

        const palletsToPrint: IStock[] = [];
        for (const detail of this.selectedForLabels) {
            const matches = this.StockAvailableForInbound.filter(
                s => s.idGood === detail.idGood && s.idInboundDeliveryNoteDetail === detail.id
            );
            palletsToPrint.push(...matches);
        }

        if (palletsToPrint.length === 0) {
            this.overlay = false;
            this.showMessageWarning("No pallets found for selected lines");
            return;
        }

        this.showTemplate = true;

        const doc = new JSPDF({ format: "a6", unit: "mm", orientation: "portrait" });

        for (let index = 0; index < palletsToPrint.length; index++) {
            if (index > 0) doc.addPage();

            this.currentItem = palletsToPrint[index];
            await this.updateQrValue();
            await this.$nextTick();

            if (this.contentToPrint) {
                const canvas = await HTML2CANVAS(this.contentToPrint, {
                    backgroundColor: "#ffffff",
                    scale: 2,
                    useCORS: true
                });
                const imgData = canvas.toDataURL("image/png");
                doc.addImage(imgData, "PNG", 0, 0, 98, 148);
            }
        }

        doc.save("labels.pdf");

        this.overlay = false;
        this.showTemplate = false;
        this.dialogPrintLabels = false;
    }
}
